var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { buttonContents } from './shared';
import { buttonStyles } from './styles';
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-button-button--playground) •
 * [Design System](https://theguardian.design/2a1e5182b/p/435225-button) •
 * [GitHub](https://github.com/guardian/source/tree/main/src/core/components/button) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-button)
 *
 * Buttons enable users to make choices or perform actions.
 *
 */
export const LinkButton = (_a) => {
    var { priority, size, iconSide, icon: iconSvg, nudgeIcon, hideLabel, cssOverrides, children } = _a, props = __rest(_a, ["priority", "size", "iconSide", "icon", "nudgeIcon", "hideLabel", "cssOverrides", "children"]);
    return (_jsx("a", Object.assign({ css: buttonStyles({
            size,
            priority,
            icon: iconSvg,
            hideLabel,
            iconSide,
            nudgeIcon,
            cssOverrides,
        }) }, props, { children: buttonContents({
            hideLabel,
            iconSvg,
            children,
        }) }), void 0));
};
//# sourceMappingURL=LinkButton.js.map
